import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import ThemeContext from "../../../../Context/theme/ThemeContext";
import AlertContext from "../../../../Context/Alert/AlertContext";

const CreatePortfolio = () => {
  const { theme } = useContext(ThemeContext);
  const { showAlert } = useContext(AlertContext);
  const navigate = useNavigate();
  const [PortfolioType, setPortfolioType] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleNext = () => {
    try {
      setIsLoading(true);

      if (!PortfolioType) {
        showAlert("Please select a portfolio type", "warning");
        return;
      }

      if (PortfolioType === "Portfolio") {
        navigate("/user-dashboard/profile/porfile_creation");
      } else if (PortfolioType === "MarketPlace") {
        navigate("/user-dashboard/profile/marketplace_creation");
      }
    } catch (error) {
      showAlert("Something went wrong", "danger");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex items-center font-pop flex-col">
      <div
        className={` rounded-2xl py-6 px-6 my-6 w-[95%] md:w-[70%] xl:w-[40%] flex flex-col gap-4
             ${theme == "dark" ? "bg-black text-white" : "bg-white "} `}
      >
        <h1
          className={`font-semibold text-xl
  ${theme == "dark" && "text-white"}`}
        >
          Create portfolio
        </h1>
        <div className="flex flex-col gap-4">
          <div
            className={`flex gap-4 items-center border-2 border-light rounded-2xl py-4 px-6 cursor-pointer ${
              PortfolioType == "Portfolio" &&
              "border-primarygreen bg-primarygreen/30"
            }`}
            onClick={() => {
              setPortfolioType("Portfolio");
            }}
          >
            <h2 className="font-medium">For my portfolio</h2>
          </div>
          <div
            className={`flex gap-4 items-center border-2 border-light rounded-2xl py-4 px-6 cursor-pointer ${
              PortfolioType == "MarketPlace" &&
              "border-primarygreen bg-primarygreen/30"
            }`}
            onClick={() => {
              setPortfolioType("MarketPlace");
            }}
          >
            <h2 className="font-medium">Marketplace</h2>
          </div>

          <button
            className={`my-4 px-2 md:px-6 bg-green-500 hover:bg-transparent  hover:bg-white-500 font-medium hover:text-black font-pop text-sm md:text-lg py-2 md:py-3 border border-black-500 hover:border-green-500 rounded-full  text-white
                        ${
                          theme === "dark"
                            ? "hover:text-white"
                            : "hover:text-black"
                        } 
                        ${
                          isLoading
                            ? "opacity-50 cursor-not-allowed"
                            : "cursor-pointer"
                        }`}
            onClick={handleNext}
            disabled={isLoading}
          >
            {isLoading ? (
              <div className="flex items-center justify-center">
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
              </div>
            ) : (
              "Next"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreatePortfolio;
